import React, { useCallback, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import { setLoading } from "../../../redux/loading"
import { IRedux } from "../../../services/types"
import { setCreationMode } from "../../../redux/inscription"
import EmployeeApi from "../../../services/api/Employee.api"
import { IEmployee } from "../../../interfaces/employee"
import AddCompanyTd from "./addCompany.td"

const AddCompanyTable = () => {
  const dispatch = useDispatch()

  const user = useSelector((state: IRedux) => state.user)

  const [employees, setEmployees] = useState<IEmployee[]>([])

  const fetchCompanies = useCallback(async () => {
    dispatch(setLoading(true))
    setEmployees(await new EmployeeApi().getAllByUserId(user.id))
    dispatch(setLoading(false))
  }, [dispatch, user.id])

  useEffect(() => {
    fetchCompanies()
  }, [fetchCompanies])

  return (
    <div>
      <div className="table-container">
        <table className="table is-striped is-bordered is-fullwidth">
          <thead>
            <tr>
              <th>Nom</th>
              <th>Code postal</th>
              <th>Adresse</th>
              <th> </th>
            </tr>
          </thead>
          <tbody>
            {employees.map(e => (
              <AddCompanyTd company={e.Company} key={e.id} />
            ))}
          </tbody>
        </table>
      </div>

      <div className="has-text-weight-semibold" style={{ marginBottom: 5 }}>
        Une organisation n'est pas dans la liste ci-dessus ?
      </div>
      <button
        type="button"
        className="button is-primary"
        style={{ marginBottom: 10 }}
        onClick={() => dispatch(setCreationMode())}
      >
        Créer une nouvelle organisation
      </button>
    </div>
  )
}

export default AddCompanyTable
